import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { CraeteTitleCmsrDTO, ShopApiService } from 'features/shop-item/api/shop-api.service';
import { queryClient } from 'providers';


const { createSize } = ShopApiService();

export const useCreateSize = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteTitleCmsrDTO) => {
            return createSize(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                // queryClient.invalidateQueries({
                //     queryKey: eventsQueryKeys.all,
                // });
                // message.success(i18n.t('fields.create.successfulCreate'));
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    message.success("Size added successfully");
                }
            },
        },
    );
};
